module.exports = __webpack_public_path__ + "static/media/left-page.df9846bc.svg";